import React, { useState, useRef } from 'react';

export default function AudioRecorder() {
    const [isRecording, setIsRecording] = useState(false);
    const [audioURL, setAudioURL] = useState('');
    const [isPlaying, setIsPlaying] = useState(false);
    const [error, setError] = useState('');

    const mediaRecorderRef = useRef(null);
    const audioRef = useRef(null);
    const chunksRef = useRef([]);

    const startRecording = async () => {
        try {
            setError('');
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            mediaRecorderRef.current = new MediaRecorder(stream);
            chunksRef.current = [];

            mediaRecorderRef.current.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    chunksRef.current.push(event.data);
                }
            };

            mediaRecorderRef.current.onstop = () => {
                const blob = new Blob(chunksRef.current, { type: 'audio/wav' });
                const url = URL.createObjectURL(blob);
                setAudioURL(url);

                // Stop all tracks to release the microphone
                stream.getTracks().forEach(track => track.stop());
            };

            mediaRecorderRef.current.start();
            setIsRecording(true);

        } catch (err) {
            setError('Error geen toegang tot microfoon: ' + err.message);
            console.error('Error accessing microphone:', err);
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
        }
    };

    const togglePlayback = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleAudioEnded = () => {
        setIsPlaying(false);
    };

    const downloadRecording = () => {
        if (audioURL) {
            const link = document.createElement('a');
            link.href = audioURL;
            link.download = `recording-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.wav`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg">
            {error && (
                <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                    {error}
                </div>
            )}

            <div className="flex flex-col items-center space-y-4">
                {/* Recording Controls */}
                <div className="flex space-x-4">
                    <button
                        onClick={startRecording}
                        disabled={isRecording}
                        className={`btn btn-primary btn-raised ${isRecording
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-red-500 text-white hover:bg-red-600'
                            }`}
                    >
                        <span>Opnemen</span>
                    </button>

                    <button
                        style={{ marginLeft: 10 }}
                        onClick={stopRecording}
                        disabled={!isRecording}
                        className={`btn btn-primary btn-raised ${!isRecording
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-gray-700 text-white hover:bg-gray-800'
                            }`}
                    >
                        <span>Stop opname</span>
                    </button>
                </div>

                {/* Recording Status */}
                {isRecording && (
                    <div className="flex items-center space-x-2 text-red-600">
                        <div className="w-3 h-3 bg-red-600 rounded-full animate-pulse"></div>
                        <span className="font-medium">Spreek je bericht in, de opname loopt...</span>
                    </div>
                )}

                {/* Playback Controls */}
                {audioURL && (
                    <div className="w-full space-y-4">
                        <div className="border-t pt-4">
                            <span>Niet tevreden met onderstaande opname? Begin dan opnieuw met opnemen.</span>
                            <br/>
                            <audio
                                ref={audioRef}
                                src={audioURL}
                                onEnded={handleAudioEnded}
                                className="w-full mb-3"
                                controls
                            />

                            <div className="flex space-x-3">
                                <button
                                    onClick={downloadRecording}
                                    className="btn btn-primary btn-raised"
                                >
                                    <span>Download opname</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}